<template>
  <div class="checkout-cardform">
    <VCreditCard noCard @change="creditInfoChanged" />
  </div>
</template>

<script>
import VCreditCard from "v-credit-card";
import "v-credit-card/dist/VCreditCard.css";
export default {
  name: "CheckoutCardForm",
  components: {
    VCreditCard
  },
  data() {
    return {
      card: ""
    };
  },
  methods: {
    creditInfoChanged(values) {
      this.card = values;
    }
  }
};
</script>

<style lang="scss">
.credit-card-form {
  padding-left: 0;
}
</style>
